import { AvvirEvent } from "type_aliases";

export type TosAcceptedEvent = AvvirEvent<typeof TOS_ACCEPTED, { id: number }>

const tosAccepted = (id: number): TosAcceptedEvent => ({
  type: TOS_ACCEPTED,
  payload: { id }
});

export const TOS_ACCEPTED = "tos_accepted";

export default tosAccepted;
